export default {
  industryVersion: [
    {
      icon: require('@/assets/images/industry-version/icon_01@2x.png'),
      name: '通用零售',
      desc: '批量盘点 | 批量出入库 | 业绩提成',
      id: 82,
      isChecked: false,
      isAvailable: false
    }, {
      icon: require('@/assets/images/industry-version/qijian@2x.png'),
      name: '旗舰版',
      desc: '功能任选 | 全行业支持 ',
      id: 132,
      isChecked: false,
      isAvailable: false
    }, {
      icon: require('@/assets/images/industry-version/icon_02@2x.png'),
      name: '服装/鞋/帽',
      desc: '颜色尺码 | 条码打印 | 业绩提成',
      id: 67,
      isChecked: false,
      isAvailable: false
    }, {
      icon: require('@/assets/images/industry-version/icon_05@2x.png'),
      name: '美业/丽人',
      desc: '会员预约 | 会员多计次卡  | 业绩提成',
      id: 77,
      isChecked: false,
      isAvailable: false
    }, {
      icon: require('@/assets/images/industry-version/restaurant-@2x.png'),
      name: '餐饮行业版',
      desc: '台位管理 | 后厨打印 | 加料管理',
      id: 76,
      isChecked: false,
      isAvailable: false
    }, {
      icon: require('@/assets/images/industry-version/icon_04@2x.png'),
      name: '母婴亲子',
      desc: '颜色尺码 | 保质期 | 条码打印 | 婴儿档案 | 业绩提成',
      id: 73,
      isChecked: false,
      isAvailable: false
    }, {
      icon: require('@/assets/images/industry-version/icon_03@2x.png'),
      name: '数码电子',
      desc: '串号管理 | 业绩提成',
      id: 68,
      isChecked: false,
      isAvailable: false
    }, {
      icon: require('@/assets/images/industry-version/chongwu@2x.png'),
      name: '宠物版',
      desc: '预约管理 | 宠物信息管理 | 会员储值',
      id: 124,
      isChecked: false,
      isAvailable: false
    }, {
      icon: require('@/assets/images/industry-version/glasses@2x.png'),
      name: '眼镜版',
      desc: '库存管理 | 验光单管理 | 会员储值',
      id: 126,
      isChecked: false,
      isAvailable: false
    }]
}



// WEBPACK FOOTER //
// ./src/model/industry-version/industry-entity.js